<template>
  <div class="row" v-if="canAccess">
    <div class="col-md-3">
      <div class="card">
        <div class="row">
          <div class="col-md-12">
            <div class="card-body">
              <a-menu
                v-model:selectedKeys="selectedKeys"
                mode="inline"
                @click="handleClick"
              >
                <a-menu-item key="system"> System Config </a-menu-item>
                <a-menu-item key="payment" v-if="role === 'admin'">
                  ช่องทางการชำระเงิน
                </a-menu-item>
                <a-menu-item key="banner" v-if="role === 'admin'">
                  จัดการ Banner
                </a-menu-item>
              </a-menu>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-9">
      <div class="card" v-if="current === 'system'">
        <div class="row">
          <div class="col-md-12">
            <div class="card-header">
              <h5 class="card-title">การตั้งค่าระบบ</h5>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row" v-if="midasbuy">
            <div class="col-md-3">
              <p>การเช็ค UID Midasbuy</p>
            </div>
            <div class="col-md-9">
              <a-switch v-model:checked="midasbuyValue">
                <template #checkedChildren>เปิดใช้งาน</template>
                <template #unCheckedChildren>ปิดใช้งาน</template>
              </a-switch>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 text-center">
              <a-button
                type="default"
                @click="
                  () => {
                    isAdmin ? onBack() : goToHome();
                  }
                "
                :disabled="midasbuySaveing"
                >ยกเลิก</a-button
              >
              &nbsp;
              <a-button
                type="primary"
                @click="onSaveMidasbuy"
                :loading="midasbuySaveing"
                >บันทึก</a-button
              >
            </div>
          </div>
        </div>
      </div>
      <div class="card" v-if="current === 'payment'">
        <div class="row">
          <div class="col-md-12">
            <div class="card-header">
              <h5 class="card-title">ตั้งค่าช่องทางการชำระเงิน</h5>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <a-table
                :columns="columns"
                :data-source="banks"
                :loading="paymentLoaded"
                :scroll="{ x: 850 }"
              >
                <template #action="{ record }">
                  <a href="#" @click="updatePayment(record.code)">แก้ไข</a>
                </template>
              </a-table>
            </div>
          </div>
        </div>
      </div>
      <div class="card" v-if="current === 'banner'">
        <div class="row">
          <div class="col-md-12">
            <div class="card-header">
              <div class="row">
                <div class="col-8">
                  <h5 class="card-title">
                    แก้ไข Banner
                    <a-typography-text type="secondary"
                      >(ขนาดรูปที่แนะนำ 1,000 x 500)</a-typography-text
                    >
                  </h5>
                </div>
                <div class="col-4 text-right">
                  <n-button type="info" @click="showBannerModal"
                    >เพิ่ม Banner</n-button
                  >

                  <n-button
                    type="default"
                    class="btn-outline-info"
                    @click="
                      () => {
                        visibleDrag = true;
                      }
                    "
                    >จัดเรียง Banner</n-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <a-table
                :columns="columns_banner"
                :data-source="banners"
                :loading="bannersLoaded"
                :scroll="{ x: 850 }"
              >
                <template #picture="{ record }">
                  <a-image :width="25" :src="record.picture" />
                </template>
                <template #action="{ record }">
                  <a href="#" @click="showBannerModal(record.id)">แก้ไข</a>
                </template>
                <template #status="{ record }">
                  <a-tag
                    :key="record.isActived"
                    :color="record.isActived ? 'green' : 'volcano'"
                  >
                    {{ record.isActived ? "ใช้งาน" : "ไม่ใช้งาน" }}
                  </a-tag>
                </template>
              </a-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" v-if="canAccess === false">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <a-result
            status="403"
            title="403"
            sub-title="ขออภัย คุณไม่ได้รับอนุญาตให้เข้าถึงหน้านี้"
          >
            <template #extra>
              <a-button type="primary" @click="goToHome">กลับหน้าหลัก</a-button>
            </template>
          </a-result>
        </div>
      </div>
    </div>
  </div>

  <a-modal
    destroyOnClose="true"
    v-model:visible="visible"
    title="แก้ไขช่องทางการชำระเงิน"
    @ok="handleOk"
    :confirm-loading="confirmLoading"
  >
    <Form
      method="#"
      action="#"
      v-on:submit="onSaveBank"
      :validation-schema="schema"
    >
      <vee-input
        label="เลขที่บัญชี"
        name="bankaccountno"
        type="text"
        :value="payment.bankAccountNo"
        placeholder="Enter account number"
      />
      <vee-input
        label="ชื่อบัญชี"
        name="bankaccountname"
        type="text"
        :value="payment.bankAccountName"
        placeholder="Enter account name"
      />
      <br />
      <button ref="submit" style="display: none">Submit</button>
    </Form>
  </a-modal>
  <a-modal
    destroyOnClose="true"
    v-model:visible="visible_banner"
    title="แก้ไข Banner"
    @ok="saveBanner"
    :confirm-loading="confirmLoading"
  >
    <p>รูป (แนะนำขนาดรูป 1,000x500)</p>
    <a-upload
      v-model:file-list="fileList"
      :openFileDialogOnClick="fileList.length < 1"
      name="file"
      :multiple="false"
      accept="image/*"
      :action="uploadUrl"
      :headers="headers"
      @change="handleChange"
    >
      <a-button>
        <upload-outlined></upload-outlined>
        Click to Upload
      </a-button>
    </a-upload>
    <br />
    <p>รายละเอียด</p>
    <a-textarea v-model:value="banner.description" showCount :maxlength="100" />
    <a-switch
      checked-children="เปิดใช้งาน"
      un-checked-children="ไม่เปิดใช้งาน"
      v-model:checked="banner.isActived"
    />
  </a-modal>
  <a-modal
    destroyOnClose="true"
    v-model:visible="visibleDrag"
    title="จัดเรียง Banner"
    @ok="onReorder"
    :confirm-loading="confirmLoading"
  >
    <draggable
      :animation="200"
      v-model="allBanners"
      group="people"
      @start="drag = true"
      @end="drag = false"
      item-key="id"
      ghost-class="moving-card"
      class="w-full max-w-md"
    >
      <template #item="{ element }">
        <div
          class="
            p-4
            mb-3
            flex
            justify-between
            items-center
            bg-white
            shadow
            rounded-lg
            cursor-move
            border border-white
          "
          style="cursor: move"
        >
          <div class="ml-2 text-gray-700 font-semibold font-sans tracking-wide">
            <a-image
              class="w-10 h-10 rounded-full"
              :width="30"
              :src="element.picture"
            />
            &nbsp;
            {{ element.description }}
          </div>
        </div>
      </template>
    </draggable>
  </a-modal>
</template>

<script>
import { CheckOutlined, CloseOutlined } from "@ant-design/icons-vue";
const key = "updatable";
import { message } from "ant-design-vue";
import { Form } from "vee-validate";
import { VeeInput } from "@/components";
import * as Yup from "yup";
import { ref } from "vue";
import draggable from "vuedraggable";

import * as configuration from "../../../middleware/configuration";
import * as userservice from "../../../services/user";
import * as paymentservice from "../../../services/payment";
import * as configservice from "../../../services/config";

const columns = [
  {
    title: "No",
    dataIndex: "no",
    key: "no",
  },
  {
    title: "ช่องทางการชำระเงิน",
    dataIndex: "paymentMethod",
    key: "paymentMethod",
  },
  {
    title: "ธนาคาร",
    dataIndex: "bank",
    key: "bank",
  },
  {
    title: "เลขที่บัญชี",
    dataIndex: "bankAccountNo",
    key: "bankAccountNo",
  },
  {
    title: "ชื่อบัญชี",
    dataIndex: "bankAccountName",
    key: "bankAccountName",
  },
  {
    title: "Action",
    key: "id",
    align: "center",
    slots: { customRender: "action" },
  },
];
const columns_banner = [
  {
    title: "ลำดับ",
    dataIndex: "no",
    key: "no",
    width: 85,
  },
  {
    title: "รูป",
    key: "picture",
    slots: { customRender: "picture" },
    width: 85,
  },
  {
    title: "รายละเอียด",
    key: "description",
    dataIndex: "description",
  },
  {
    title: "สถานะ",
    key: "status",
    align: "center",
    slots: { customRender: "status" },
    width: 100,
  },
  {
    title: "Action",
    key: "id",
    align: "center",
    slots: { customRender: "action" },
  },
];
export default {
  components: {
    CheckOutlined,
    CloseOutlined,
    VeeInput,
    Form,
    draggable,
  },
  methods: {
    handleClick(e) {
      this.current = e.key;
    },
    async getConfig() {
      try {
        let res = await userservice.getConfig();
        this.config = res.data;
        this.midasbuy = res.data.find((x) => x.optionName === "CHECK_MIDASBUY");
        this.midasbuyValue = this.midasbuy.optionValue === "true";
      } catch (error) {
        console.log(error);
      } finally {
        this.configLoaded = true;
      }
    },
    async onSaveMidasbuy() {
      this.midasbuySaveing = true;
      message.loading({ content: "กำลังบันทึก...", key });
      this.midasbuy.updatedBy = this.uid;
      let data = this.midasbuy;
      data.optionValue = this.midasbuyValue.toString();

      try {
        let res = await userservice.saveConfig(data);
        this.config = res.data;
        this.midasbuy = res.data.find((x) => x.optionName === "CHECK_MIDASBUY");
        this.midasbuyValue = this.midasbuy.optionValue === "true";
        message.success({ content: "บันทึกขอมูลสำเร็จ!", key, duration: 2 });
      } catch (error) {
        message.error({
          content: "บันทึกขอมูลไม่สำเร็จ! " + err,
          key,
          duration: 2,
        });
      } finally {
        this.midasbuySaveing = false;
      }
    },
    async getBanks() {
      try {
        let res = await paymentservice.getBanks();
        res.data.map((d, i) => {
          d.no = i + 1;
          d.paymentMethod = "โอนเงินธนาคาร";
          d.bank = d.bankName;
          d.bankAccountNo = d.accountNo;
          d.bankAccountName = d.accountName;
        });
        this.banks = res.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.banksLoaded = true;
      }
    },
    async getBanner() {
      try {
        let res = await configservice.getBanner();
        this.banners = res.data;
        this.allBanners = res.data;
      } catch (error) {
        console.log(error);
      }
    },
    showBannerModal(id) {
      let banner = this.banners.find((x) => x.id === id);
      this.banner = {
        id: id,
        picture: banner.picture,
        description: banner.description,
        isActived: banner.isActived,
      };
      this.visible_banner = true;
    },
    getUploadUrl() {
      this.uploadUrl = configservice.getUploadUrl();
    },
    async saveBanner() {
      this.confirmLoading = true;
      var image = this.fileList.shift();
      if (this.banner.id === 0 && image === undefined) {
        message.error(`กรุณาแนบรูป`);
      }

      let req = {
        id: this.banner.id,
        picture: image !== undefined ? image.response.url : this.banner.picture,
        description: this.banner.description,
        isActived: this.banner.isActived,
        uid: this.uid,
      };

      try {
        let res = await configservice.saveBanner(req);
        message.success({ content: "บันทึกขอมูลสำเร็จ!", key, duration: 2 });
        await this.getBanner();
        this.visible_banner = false;
      } catch (error) {
        console.log(error);
      } finally {
        this.confirmLoading = false;
      }
    },
    async onReorder() {
      this.confirmLoading = true;
      let banners = this.allBanners;
      let data = [];
      banners.forEach((g, i) => {
        g.no = i + 1;
        data.push({
          id: g.id,
          no: g.no,
        });
      });

      try {
        let res = await configservice.bannerReorder(data);
        if (res) {
          this.visibleDrag = false;
          message.success(`จัดเรียง Banner สำเร็จ`);
        }
      } catch (error) {
        message.error(`จัดเรียง Banner ไม่สำเร็จ กรุณาลองอีกครั้ง`);
      } finally {
        await this.getBanner();
        this.confirmLoading = false;
      }

    },
    updatePayment(code) {
      let data = this.banks.find((x) => x.code === code);
      this.payment = {
        code: code,
        bankAccountNo: data.bankAccountNo,
        bankAccountName: data.bankAccountName,
      };
      this.visible = true;
    },
    handleOk(e) {
      this.$refs.submit.click();
    },
    async onSaveBank(values) {
      this.confirmLoading = true;
      var data = {
        code: this.payment.code,
        AccountName: values.bankaccountname,
        AccountNo: values.bankaccountno,
      };

      try {
        let res = await paymentservice.saveBank(data);
        if (res) {
          this.visible = false;
          response.data.map((d, i) => {
            d.no = i + 1;
            d.paymentMethod = "โอนเงินธนาคาร";
            d.bank = d.bankName;
            d.bankAccountNo = d.accountNo;
            d.bankAccountName = d.accountName;
          });
          this.banks = res.data;
          message.success(`บันทึก ${this.payment.bankAccountName} สำเร็จ`);
        }
      } catch (error) {
        message.error({
          content: "บันทึกขอมูลไม่สำเร็จ! " + err,
          key,
          duration: 2,
        });
      } finally {
        this.confirmLoading = false;
      }
    },
  },
  data() {
    return {
      configLoaded: false,
      confirmLoading: false,
      visible: false,
      visible_banner: false,
      visibleDrag: false,
      midasbuySaveing: false,
      uid: "",
      current: "system",
      currentUser: null,
      selectedKeys: ["system"],
      canAccess: null,
      midasbuy: null,
      midasbuyValue: null,
      config: [],
      columns: columns,
      banks: [],
      columns_banner: columns_banner,
      banners: [],
      allBanners: [],
      banner: {
        id: 0,
        picture: null,
        description: "",
        isActived: true,
      },
      payment: null,
      uploadUrl: "",
    };
  },
  async beforeMount() {
    this.uid = await configuration.getUid();

    let result = await configuration.getIdTokenResult();
    if (result) {
      this.role = result.claims?.role || this.role;
      this.isAdmin = this.role === "admin" || this.role === "manager";
      if (
        this.role === "admin" ||
        this.role === "manager" ||
        this.uid === this.$route.params.id
      ) {
        await this.getConfig();
        await this.getBanks();
        await this.getBanner();
        this.getUploadUrl();
        this.canAccess = true;
      } else {
        this.canAccess = false;
      }
    } else {
      this.canAccess = false;
    }
  },

  setup() {
    const schema = Yup.object().shape({
      bankaccountno: Yup.string().required().label("The Bank account number"),
      bankaccountname: Yup.string().required().label("The Bank account name"),
    });
    const handleChange = (info) => {
      if (info.file.status !== "uploading") {
        console.log(info.file, info.fileList);
      }

      if (info.file.status === "done") {
        message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    };
    const fileList = ref([]);
    return {
      schema,
      fileList,
      handleChange,
    };
  },
};
</script>

<style>
</style>